import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { BreedViewModel, BREED_DISPLAY_FIELD } from './+state';
import { BreedConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = BreedConstants;

@Injectable({providedIn: 'root'})
export class BreedService extends BaseService<BreedViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Breed', RT.defaultApi)), BREED_DISPLAY_FIELD);
  }
}
